module.exports = __webpack_public_path__ + "img/foto-data-driven.b5c0f1b1.jpg";